import { useEndTaskDeparture } from '../../../entities/task'
import { getStartWorkErrorMessage } from '../model/getStartWorkErrorMessage'
import { EndDepartureModalView } from './EndDepartureModalView'

interface Props {
  show: boolean
  setShow: (show: boolean) => void
  taskId: number
  /** ISO `schedule.actualEndsAt` — the recorded work end the departure is measured from. */
  actualEndsAt: string | null
  onSuccess: () => void
}

export function EndTaskDepartureModal({
  show,
  setShow,
  taskId,
  actualEndsAt,
  onSuccess,
}: Props) {
  const endDeparture = useEndTaskDeparture()

  return (
    <EndDepartureModalView
      show={show}
      setShow={setShow}
      actualEndsAt={actualEndsAt}
      isPending={endDeparture.isPending}
      errorMessage={endDeparture.isError ? getStartWorkErrorMessage(endDeparture.error) : null}
      onOpen={() => endDeparture.reset()}
      onSubmit={(dto) => endDeparture.mutate({ id: taskId, dto }, { onSuccess })}
    />
  )
}
